import http from './webhook/httpconfig'
import { cancelHTTPRequests } from '@/services/utils'
import AppWarn from './errors/app-warns'

async function getClientConfig() {
  try {
    const response = await http.get('/api/client-config', {
        cancelToken: cancelHTTPRequests()
    })
    
    return response.data?.payload || {}
  } catch (err) {
    throw new AppWarn({name: 'Get Client Config', message:`Error while getting client config. ${err.message}`})
  }
}

export { getClientConfig }